import { render, staticRenderFns } from "./PersonnalInfo.vue?vue&type=template&id=41646538&scoped=true"
import script from "./PersonnalInfo.vue?vue&type=script&lang=ts"
export * from "./PersonnalInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41646538",
  null
  
)

export default component.exports